export default "__VITE_ASSET__Ob9q18GX__ 15149w";